<template>
    <button class="remove-button-styling" @click.prevent="openThreeDeeModal()">
        <BaseIcon color="#347F7F" height="40" stroke-width="1.5" width="40">
            <Icon360 />
        </BaseIcon>
        <p class="uk-margin-remove" style="color: #347F7F;">View 3D</p>
    </button>
</template>

<script setup>
import BaseIcon from "./BaseIcon";
import Icon360 from "../icons/Icon360.vue";

const props = defineProps({
    url: String
})

function openThreeDeeModal() {
    $('#modal-three-dee-iframe').attr('src', props.url)

    UIkit.modal('#modal-three-dee', {stack: true}).show()
}
</script>
